import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export default async function postClockInRecord(record, activeEmployerInfo) {
  const apiPath = `${record.project}/records/clock-in-record`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: record,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
}
